import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import logo from "@/assets/logo.png";
import { LuLoader2 } from "react-icons/lu";

import Index from "@/scenes/index.jsx";
import Identification from "@/scenes/identification.jsx";
import Question from "@/scenes/question.jsx";
import CheckInQuestions from "@/scenes/checkInQuestions.jsx";
import MoreQuestions from "@/scenes/moreQuestions.jsx";
import Confirmation from "@/scenes/confirmation.jsx";
import CheckIn from "@/scenes/checkIn.jsx";
import Guidelines from "@/scenes/guidelines.jsx";
import Terms from "@/scenes/terms.jsx";
import Privacy from "@/scenes/privacy.jsx";
import Cookies from "@/scenes/cookies.jsx";
import { LoadingProvider } from "@/context/LoadingContext.jsx";
import { useLoading } from "@/context/LoadingContext.jsx";
import CookieBanner from "@/components/CookieBanner.jsx";

const AppContent = () => {
  const { isLoading } = useLoading();

  return (
    <>
      {isLoading && <LoadingSpinner />}
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/identification" element={<Identification />} />
        <Route path="/question" element={<Question />} />
        <Route path="/confirmation" element={<Confirmation />} />
        <Route path="/guidelines" element={<Guidelines />} />
        <Route path="/check-in" element={<CheckIn />} />
        <Route path="/check-in-questions" element={<CheckInQuestions />} />
        <Route path="/more-questions" element={<MoreQuestions />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/cookies" element={<Cookies />} />
      </Routes>
      <CookieBanner />
    </>
  );
};

const LoadingSpinner = () => {
  return (
    <div className="fixed inset-0 bg-white z-[9999] flex flex-col items-center justify-center">
      <div className="mb-6">
        <img src={logo} alt="Logo" className="h-16" />
      </div>
      <LuLoader2 className="text-primary animate-spin h-12 w-12" />
    </div>
  );
};

const App = () => {
  return (
    <LoadingProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </LoadingProvider>
  );
};

export default App;
